import React from 'react';
import './Sidebar.css';
import { useTranslation } from 'react-i18next';

function importAll(r) { let images = {}; r.keys().forEach((item) => { images[item.replace('./', '')] = r(item); }); return images; }
const images = importAll(require.context('../assets/images', false, /\.(png|jpe?g|svg)$/));

function Sidebar({ songs, onSongSelect, onPlayClick, activeSongId, selectedSong, isPlaying }) {
  const { t, i18n } = useTranslation();
  const handleInlinePlay = (e, index) => { e.stopPropagation(); onPlayClick(index); };

  return (
    <div className="sidebar-container">
      <div className="library-header"><h3>{t('navLibrary')}</h3></div>
      <div className="song-list-sidebar">
        {songs.map((song, index) => {
          const isActive = activeSongId === song.id;
          const isPlayingAndActive = isPlaying && isActive;
          const isPausedAndActive = !isPlaying && isActive;
          const isSelectedForView = selectedSong && selectedSong.id === song.id;
          
          let itemClass = 'sidebar-song-item';
          if (isPausedAndActive) { itemClass += ' active-paused'; }
          if (isSelectedForView) { itemClass += ' selected'; }
          if (isPlayingAndActive) { itemClass += ' playing'; }

          return (
            <div className={itemClass} key={song.id} onClick={() => onSongSelect(song)}>
              <div className="sidebar-song-art-container">
                <img src={images[song.imageSrc]} alt={song.title[i18n.language]} className="sidebar-song-art" />
                <button className="sidebar-play-button" onClick={(e) => handleInlinePlay(e, index)}><i className={isPlayingAndActive ? "fas fa-pause" : "fas fa-play"}></i></button>
              </div>
              <div className="sidebar-song-info">
                <span className="sidebar-song-title">{song.title[i18n.language]}</span>
                <span className="sidebar-song-artist">{song.artist[i18n.language]}</span>
              </div>
              {isPlayingAndActive && (
                <div className="sound-wave-icon">
                  <span></span><span></span><span></span><span></span>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Sidebar;